import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Unpin = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8249 2.08135C11.6886 2.02965 11.5258 2 11.3332 2H4.66658C3.41658 2 3.41658 3.25 3.83325 3.66667L4.91098 4.74447C5.28799 5.12151 5.49979 5.63288 5.49976 6.16608C5.49974 6.6992 5.28796 7.21048 4.91101 7.58747L3.83324 8.66536C3.54174 8.95682 3.45412 9.65649 3.85563 10.0507L5.73155 8.17475C6.2249 7.62411 6.49973 6.90929 6.49976 6.16613C6.4998 5.36771 6.18266 4.60198 5.61811 4.03739L4.58656 3.00577L4.58633 3.00439C4.60681 3.00189 4.6333 3 4.66658 3H10.9063L11.8249 2.08135ZM6.73107 9.33204L6.7494 9.33203C7.25913 9.33179 7.68746 9.71499 7.74375 10.2216L7.99987 12.5266L8.25599 10.2216C8.31228 9.71499 8.74061 9.33179 9.25034 9.33203L11.3332 9.333C11.3665 9.333 11.3931 9.3311 11.4136 9.32859L11.4132 9.32625L10.3815 8.29464C9.95275 7.86592 9.66668 7.32119 9.55386 6.73423L10.5265 5.83908C10.5088 5.94644 10.4998 6.05574 10.4998 6.16596C10.4997 6.69915 10.7115 7.2105 11.0886 7.5875L12.1665 8.66536C12.5832 9.08203 12.5832 10.333 11.3332 10.333L9.24987 10.332L8.8332 14.082C8.8332 15.6668 7.16654 15.6668 7.16654 14.082L6.74987 10.332L5.64392 10.3325L6.73107 9.33204Z"
      />
      <path
        fill={color}
        d="M13.6465 1.35356C13.8417 1.1583 14.1583 1.1583 14.3536 1.35356V1.35356C14.5489 1.54882 14.5489 1.86541 14.3536 2.06067L2.06066 14.3536C1.8654 14.5488 1.54882 14.5488 1.35355 14.3536V14.3536C1.15829 14.1583 1.15829 13.8417 1.35355 13.6464L13.6465 1.35356Z"
      />
    </svg>
  )
})

export default Unpin
